const Header = () => {
  return (
    <h2 className="text-center drop-shadow-lg py-[16px] bg-blue-400 text-2xl mb-[16px] text-white">
      Header
    </h2>
  );
};

export default Header;
